import React, { useEffect } from 'react';
import globalErrorStore from '../stores/globalErrorStore';
import { useHookstate } from '@hookstate/core';
import AlertMessage from './controls/AlertMessage';

const Error = () => {

    const globalErrorState = useHookstate(globalErrorStore);
    let currentError;
    useEffect(() => {
        const errors = globalErrorState.get();
        currentError = "number of errors: " + errors.length;
    }, [globalErrorState]);

    const renderError = <>{
        currentError && <AlertMessage>
            {currentError}
        </AlertMessage>
    }</>

    return renderError;
}

export default Error;